import axios from "axios";

/* const HOST =
  process.env.API_IP + ":" + process.env.API_PORT + "/enesapi/client"; */

const HOST = process.env.API_IP + "/enesapi/client";

const instance = axios.create({
  baseURL: HOST,
});

export { instance, HOST };



// WEBPACK FOOTER //
// ./src/store/axios.js